<template>
  <Message>
    <QuickConversationSiaAvatar />

    <MessageContent>
      <div>
        <p
          v-for="msg in defaultMessages"
          class="mb-0"
        >
          {{ msg }}
        </p>
      </div>
    </MessageContent>
  </Message>
</template>

<script setup>
import { Message, MessageContent } from '@/components/common/message'
import QuickConversationSiaAvatar from './quick-conversation-sia-avatar.vue'
import { useQuickConversation } from './use-quick-conversation.js'

const { defaultMessages } = useQuickConversation()
</script>
